
import {Container} from 'react-bootstrap';
import {useRef, useEffect, useState, useLayoutEffect} from "react";
import {HashLink } from 'react-router-hash-link';
import {Link} from 'react-router-dom';
import {AiOutlineMenu} from 'react-icons/ai';
import {Img} from "../../UI/Img/index";
import logo from '../../../images/logo.png';
import './TopNavigation.scss';

const TopNavigation = ({passNavigationHeight}) => {

    const topElement = useRef(null);
    const [currentActiveUrl, setCurrentActiveUrl] = useState(null)
    const [isShown, setIsShown] = useState(true);
    const [opaque, setOpaque] = useState({opacity: 1});
    const [displayArray, setDisplayArray] = useState({dropdawnDisplay: 'none', menuDisplay: 'block'})

    const [menuContent, setMenuContent] = useState([])
    const [appState, setAppState] = useState({
        loading: false,
        repos: null,
      });

    useLayoutEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/getMenuPointsActive`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify('test'),
        }).then((response) => {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                const changedData = data.map((pointItem) => ({
                    id: pointItem.id, 
                    title: pointItem.pointTitle, 
                    link: pointItem.linkAddress, 
                }))
                setMenuContent(changedData)
            });
            setAppState({ loading: false, repos: response});
        }).catch(function(error) {
            console.log(error)
        }).then(
                fetch(`${process.env.REACT_APP_API_URL}/getCurrentActiveFormUrl`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify('test'),
            }).then((response) => {
                response.text().then(text => {
                    const data = text && JSON.parse(text);
                    setCurrentActiveUrl(data)
                });
                setAppState({ loading: false, repos: response});
            }).catch(function(error) {
                console.log(error)
            }))
    }, [setAppState])


    useEffect(() => {
        passNavigationHeight(topElement.current.offsetHeight)
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", () =>
                setOpaque({opacity: 0.92})
            );
          }

        if(topElement.current.offsetWidth > 1100) {
            setDisplayArray({dropdawnDisplay: 'none', menuDisplay: 'block'})
        }
        else {setDisplayArray({dropdawnDisplay: 'block', menuDisplay: 'none'})}

    }, []);

    const handleClick = () => {
      setIsShown(current => !current);
    };

    return (
        <Container fluid className = "top-navbar" ref={topElement} style={opaque}>
            <Link to="/" className="site-name">
                <Img src={logo} classes={['logo']}/>
            </Link>
            <div className="top-navbar__links">
                <div style={{display: displayArray.menuDisplay}}>
                    {menuContent && menuContent?.map((item) => (
                        <HashLink key={item.id} to={item.link}>{item.title}</HashLink>
                    ))}
                </div>
                <Link to={`/forms/${currentActiveUrl}`} className="pull-btn">
                    Анкетирование
                </Link>
                <div style={{display: displayArray.dropdawnDisplay}}>
                    <button className="navigation-btn" onClick={handleClick}>
                        <AiOutlineMenu/>
                    </button>
                    <div className="dropdown-content" style={{display: isShown ? 'none' : 'flex'}}>
                        {menuContent && menuContent?.map((item) => (
                            <HashLink key={item.id} to={item.link} onClick={() => {setIsShown('none')}}>{item.title}</HashLink>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default TopNavigation;